module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8019.ae584562.png";